module.exports = __webpack_public_path__ + "static/img/pickup-doublecab-grey.99a3888.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pickup-doublecab-grey.svg
// module id = IOiJ
// module chunks = 82